import { Button, Card, CircularProgress, Grid, InputLabel } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Swal from 'sweetalert2';

import { UploadImage } from '../../components';
import { getGlobalData, updInfoUmum } from '../../redux/actions/GlobalActions';

const EditInformasiUmum = () => {
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({});
  const handleChange = ({ target: { value, name } }) => {
    setParams((pref) => ({
      ...pref,
      [name]: value,
    }));
  };
  const handleFormSubmit = () => {
    setSubmit(true);
    updInfoUmum(params)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    });
  };
  const getData = useCallback(() => {
    setLoading(true);
    getGlobalData()
      .then((res) => {
        let data = res.data?.data;
        if (Object.keys(data).length > 0) {
          setParams((pref) => ({
            ...pref,
            ...data,
            company_logo: "",
            company_logo_preview: data?.company_logo,
            company_logo_ori: data?.company_logo_ori,
            company_logo_white: "",
            company_logo_white_preview: data?.company_logo_white,
            company_logo_ori_white: data?.company_logo_white_ori,
          }));
        } else {
          showAlert("Gagal mengambil data, coba beberapa saat lagi", false);
        }
        setLoading(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal mengambil data, coba beberapa saat lagi",
          false
        );
        setLoading(false);
      });
  }, []);
  useEffect(() => {
    getData();
  }, [getData]);

  const handleChangeFoto = (name, file) => {
    setParams((pref) => ({
      ...pref,
      [name]: file,
      [name+'_preview']: file,
    }));
  };
  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">Informasi Umum - Data</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="py-5 px-6 border-radius-0">
            {loading ? (
              <div className="text-center">
                <CircularProgress color="primary" size={35} />
              </div>
            ) : (
              <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <h4 className="fw-bold">Logo Website</h4>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <UploadImage
                      uploadFoto={(file) => handleChangeFoto("company_logo", file)}
                      label="Unggah Logo Berwarna"
                      preview={params?.company_logo_preview}
                      required={true}
                      noCrop
                      formatIcon={true}
                      note={[
                        "Format SVG atau WEBP diperbolehkan",
                        "*Ukuran foto 139 x 64",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <UploadImage
                      uploadFoto={(file) => handleChangeFoto("company_logo_white", file)}
                      label="Unggah Logo Putih"
                      preview={params?.company_logo_white_preview}
                      required={true}
                      noCrop
                      formatIcon={true}
                      note={[
                        "Format SVG atau WEBP diperbolehkan",
                        "*Ukuran foto 139 x 64",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <h4 className="fw-bold">Kontak</h4>
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="company_phone" className="mb-4">
                      Telepon <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="company_phone"
                      placeholder="Telepon"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="company_phone"
                      value={params.company_phone || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Telepon terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="company_fax" className="mb-4">
                      Fax <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="company_fax"
                      placeholder="Fax"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="company_fax"
                      value={params.company_fax || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Fax terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="company_email" className="mb-4">
                      Email <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="company_email"
                      placeholder="Fax"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="company_email"
                      value={params.company_email || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Fax terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <h4 className="fw-bold">Alamat</h4>
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="company_address" className="mb-4">
                      Deskripsi <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="company_address"
                      placeholder="Full Alamat"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="company_address"
                      value={params.company_address || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Full Alamat terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="lat" className="mb-4">
                      Latitude <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="lat"
                      placeholder="Latitude"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="lat"
                      value={params.lat || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Latitude terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="lng" className="mb-4">
                      Longtitude <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="lng"
                      placeholder="Longtitude"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="lng"
                      value={params.lng || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Longtitude terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="company_email" className="mb-4">
                      Email <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="company_email"
                      placeholder="Email"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="company_email"
                      value={params.company_email || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Email terlebih dahulu"]}
                    />
                  </Grid>
                </Grid>

                <h4 className="fw-bold mb-5 mt-10">Sosial Media</h4>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="youtube_link" className="mb-4">
                      Youtube <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="youtube_link"
                      placeholder="Youtube Link"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="youtube_link"
                      value={params.youtube_link || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Youtube Link terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="instagram_link" className="mb-4">
                      Instagram <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="instagram_link"
                      placeholder="Instagram Link"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="instagram_link"
                      value={params.instagram_link || ""}
                      validators={["required"]}
                      errorMessages={[
                        "Masukkan Instagram Link terlebih dahulu",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel htmlFor="facebook_link" className="mb-4">
                      Facebook <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="facebook_link"
                      placeholder="Facebook Link"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="facebook_link"
                      value={params.facebook_link || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Facebook Link terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      spacing={2}
                      justifyContent="flex-end"
                      className="flex-column-reverse flex-md-row"
                    >
                      <Grid item xs={12} md={2}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          className="text-white w-full radius-6 text-capitalize py-2"
                          disableElevation
                          disabled={submit}
                        >
                          {submit ? (
                            <CircularProgress color="primary" size={25} />
                          ) : (
                            "Simpan"
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            )}
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default EditInformasiUmum;
